import type { ComponentStyleConfig } from "@chakra-ui/react";

export const Link: ComponentStyleConfig = {
  baseStyle: {
    color: "neon.blue",
    textDecoration: "underline",
    fontSize: "16px",
  },
};
